/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RosettaAccountBalanceResponseCoinIdentifier,
    RosettaAccountBalanceResponseCoinIdentifierFromJSON,
    RosettaAccountBalanceResponseCoinIdentifierFromJSONTyped,
    RosettaAccountBalanceResponseCoinIdentifierToJSON,
    RosettaAmount,
    RosettaAmountFromJSON,
    RosettaAmountFromJSONTyped,
    RosettaAmountToJSON,
} from './';

/**
 * If a blockchain is UTXO-based, all unspent Coins owned by an account_identifier should be returned alongside the balance. It is highly recommended to populate this field so that users of the Rosetta API implementation don't need to maintain their own indexer to track their UTXOs.
 * @export
 * @interface RosettaCoin
 */
export interface RosettaCoin {
    /**
     * 
     * @type {RosettaAccountBalanceResponseCoinIdentifier}
     * @memberof RosettaCoin
     */
    coin_identifier: RosettaAccountBalanceResponseCoinIdentifier;
    /**
     * 
     * @type {RosettaAmount}
     * @memberof RosettaCoin
     */
    amount: RosettaAmount;
}

export function RosettaCoinFromJSON(json: any): RosettaCoin {
    return RosettaCoinFromJSONTyped(json, false);
}

export function RosettaCoinFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaCoin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coin_identifier': RosettaAccountBalanceResponseCoinIdentifierFromJSON(json['coin_identifier']),
        'amount': RosettaAmountFromJSON(json['amount']),
    };
}

export function RosettaCoinToJSON(value?: RosettaCoin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coin_identifier': RosettaAccountBalanceResponseCoinIdentifierToJSON(value.coin_identifier),
        'amount': RosettaAmountToJSON(value.amount),
    };
}

